// arise-frontend/src/hooks/useAnalysis.js — FINAL AUTHORITATIVE VERSION
import { useState, useCallback } from 'react';
import { analyzeFile, openJob as openJobApi, MOCK_RESULT } from '../services/api';

const STAGES = ['extraction','behaviour','capability','mitre','risk','cvss','verdict'];

export function useAnalysis() {
  const [status,  setStatus]  = useState('idle');
  const [result,  setResult]  = useState(null);
  const [error,   setError]   = useState(null);
  // HTTP status of the failure (e.g. 429 = analysis quota exhausted), or null.
  const [errorStatus, setErrorStatus] = useState(null);
  const [stage,   setStage]   = useState('');
  const [pct,     setPct]     = useState(0);
  const [taskId,  setTaskId]  = useState(null);

  const begin = () => {
    setError(null);
    setErrorStatus(null);
    setResult(null);
    setStage('');
    setPct(0);
    setTaskId(null);
  };

  const fail = e => {
    setError(e.message);
    setErrorStatus((e && e.status) || null);
    setStatus('error');
  };

  const onProgress = (s, p) => { setStage(s); setPct(p); };

  const analyze = useCallback(async (file, demo = false) => {
    begin();
    setStatus('uploading');

    try {
      if (demo) {
        setStatus('processing');
        for (let i = 0; i < STAGES.length; i++) {
          setStage(STAGES[i]);
          setPct(Math.round(((i + 1) / STAGES.length) * 90));
          await new Promise(r => setTimeout(r, 380));
        }
        setPct(100);
        await new Promise(r => setTimeout(r, 250));
        setResult(MOCK_RESULT);
        setTaskId('demo');
        setStatus('done');
      } else {
        setStatus('processing');
        const { result: data, taskId: tid } = await analyzeFile(file, onProgress);
        setResult(data);
        setTaskId(tid);
        setStatus('done');
      }
    } catch (e) {
      fail(e);
    }
  }, []);

  /** Reopen a job from history (survives page refresh: state lives on the server). */
  const openJob = useCallback(async job => {
    begin();
    setStatus('processing');
    try {
      const { result: data, taskId: tid } = await openJobApi(job, onProgress);
      setResult(data);
      setTaskId(tid);
      setStatus('done');
    } catch (e) {
      fail(e);
    }
  }, []);

  const reset = useCallback(() => {
    setStatus('idle');
    setResult(null);
    setError(null);
    setErrorStatus(null);
    setStage('');
    setPct(0);
    setTaskId(null);
  }, []);

  return { status, result, error, errorStatus, stage, pct, taskId, analyze, openJob, reset };
}
